<template>
  <v-content style="background: #273747">
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm10 md6 lg4>
          <v-card class="elevation-12">
            <slot/>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
  export default {
    name: 'MinimalLayout'
  }
</script>
